// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONFIRM = "Potvr\u010f";
export const COUNSELLING_ANSWERED = "Zodpov\u011bzen\u00e9";
export const COUNSELLING_IS_ARCHIVED = "Poradna je uzav\u0159ena";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00ed ot\u00e1zku";
export const SEO_DESCRIPTION_FORUM_POST_perex = "%(perex)s - I o tom se diskutuje na Modr\u00e9m kon\u00edku. P\u0159e\u010dti si zku\u0161enosti a n\u00e1zory ostatn\u00edch.";
export const SEO_TITLE_FORUM_POST_title = "%(title)s";
export const SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum = "%(title)s  - str. %(pagenum)s";
export const TURN_NOTIFICATIONS_OFF = "Vypni";
export const TURN_NOTIFICATIONS_ON = "Zapni";
